function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  className: styles["icon-svg"] || "icon-svg",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.309 15.191a1.497 1.497 0 001.06-.438l-.199-.2.2.2 8.49-8.491a1.5 1.5 0 00-2.122-2.122l-7.43 7.427-4.03-4.03A1.5 1.5 0 101.156 9.66l5.091 5.093a1.497 1.497 0 001.061.438zm0 0v-.3.3z"
}));